import { useState } from 'react';
import { cn } from '../ui/kit';

/**
 * IMAGE — jamais un rectangle cassé.
 *
 * Trois garanties, et c'est tout ce qu'on lui demande :
 *   1. le cadre a un **ratio fixe** : rien ne bouge quand la photo arrive (CLS = 0) ;
 *   2. avant le chargement (ou en cas d'échec), on voit une matière chaude et le
 *      monogramme de la pièce — pas une icône « image cassée » ;
 *   3. l'`alt` est obligatoire : une image sans texte alternatif n'entre pas.
 *
 * En démonstration, les photographies viennent d'Unsplash et de Commons ; elles
 * sont chargées en différé et remplacées sans heurt par la texture de repli.
 */
const TEINTES: Record<string, [string, string]> = {
  wine: ['var(--teinte-wine-100)', 'var(--teinte-wine-200)'],
  blush: ['var(--teinte-blush-100)', 'var(--teinte-blush-200)'],
  sand: ['var(--teinte-sand-100)', 'var(--teinte-sand-200)'],
  clay: ['var(--teinte-clay-100)', 'var(--teinte-clay-200)'],
  olive: ['var(--teinte-olive-100)', 'var(--teinte-olive-200)'],
  slate: ['var(--teinte-slate-100)', 'var(--teinte-slate-200)'],
};

export function Media({ src, alt, ratio = 'aspect-[4/3]', teinte = 'sand', className, monogramme, priorite, priority }: {
  src?: string | null;
  alt: string;
  ratio?: string;
  teinte?: keyof typeof TEINTES | string;
  className?: string;
  monogramme?: string;
  priorite?: boolean;
  /** Alias anglais accepté par les écrans historiques. */
  priority?: boolean;
}) {
  const [chargee, setChargee] = useState(false);
  const [echec, setEchec] = useState(false);
  const [a, b] = TEINTES[teinte] ?? TEINTES.sand;
  const initiale = monogramme ?? alt.trim().charAt(0).toUpperCase();

  return (
    <div className={cn('media', ratio, className)}
      style={{ ['--media-a' as string]: a, ['--media-b' as string]: b }}>
      <div className="media__grain" aria-hidden="true" />
      <div className="media__fallback" aria-hidden="true">
        <span>{initiale}</span>
      </div>
      {src && !echec && (
        <img
          src={src}
          alt={alt}
          loading={priorite || priority ? 'eager' : 'lazy'}
          decoding="async"
          data-chargee={chargee}
          onLoad={() => setChargee(true)}
          onError={() => setEchec(true)}
          className="absolute inset-0 h-full w-full object-cover"
          style={{ opacity: chargee ? 1 : 0 }}
        />
      )}
    </div>
  );
}
